export const ROOT_MENU = 'root';
export const SEARCH_FOCUS_DELAY = 100;
